import React from "react"
import { Link } from "gatsby"
import styled, { css } from "styled-components"
import colors from "@constants/colors"
import breakpoints from "@constants/breakpoints"
import { body16BoldStyles, body14Styles } from "@constants/typography"
import {
  MobileAndTabletContainer,
  MobileAndTabletOnly,
  DesktopOnlyContainer,
  DesktopOnly,
} from "@utils/MediaQuery"
import { BundledProduct as BundledProductType } from "@redux/types"

const Container = styled.div`
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  display: flex;
  padding: 24px 16px;

  @media ${breakpoints.tablet} {
    padding: 24px 28px;
  }

  ${MobileAndTabletContainer}, ${DesktopOnlyContainer} {
    flex-grow: 1;
  }
`

const Content = styled.div`
  position: relative;
`

const ImageLink = styled(Link)<any>`
  ${({ to }) => (!to.length ? "pointer-events: none" : "cursor: pointer")};
  flex-grow: 0;
  align-self: flex-start;
`

const ImageContainer = styled.div`
  position: relative;
  overflow: hidden;
  width: 80px;
  height: 80px;
  margin-right: 16px;

  @media ${breakpoints.laptop} {
    width: 124px;
    height: 124px;
    margin-right: 26px;
  }
`

const Image = styled.img`
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center center;
`

const Details = styled.div`
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
`

const Product = styled.div`
  ${body16BoldStyles}
  padding-right: 48px;
`

const Message = styled.div`
  ${body14Styles}
  color: ${colors.brandOrange};
`

const VerticalSpace = styled.div<{ height?: string; laptopHeight?: string }>`
  ${({ height, laptopHeight }) => css`
    height: ${height || "20px"};

    @media ${breakpoints.laptop} {
      height: ${laptopHeight || height || "20px"};
    }
  `}
`

export interface BundledProductProps {
  bundledProduct: BundledProductType
}

const BundledProduct: React.FC<BundledProductProps> = ({ bundledProduct }) => {
  return (
    <Container>
      <ImageLink to={bundledProduct.cartLink}>
        <ImageContainer>
          <Image src={bundledProduct.cartImage?.file?.url} />
        </ImageContainer>
      </ImageLink>
      <MobileAndTabletOnly>
        <Content>
          <Details>
            <Message>{bundledProduct.cartMessage}</Message>
            <VerticalSpace height="6px" />
            <Link to={bundledProduct.cartLink}>
              <Product>{bundledProduct.product}</Product>
            </Link>
          </Details>
        </Content>
      </MobileAndTabletOnly>
      <DesktopOnly>
        <Content>
          <Details>
            <Message>{bundledProduct.cartMessage}</Message>
            <VerticalSpace height="6px" />
            <Link to={bundledProduct.cartLink}>
              <Product>{bundledProduct.product}</Product>
            </Link>
          </Details>
        </Content>
      </DesktopOnly>
    </Container>
  )
}

export default BundledProduct
